import type { Business } from '@/modules/dashboard/dashboardTypes';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export const useSelectedBusinessData = () => {
	const [selectedBusiness] = useSelector<RootState, [Business | null]>(
		state => [state.dashboard.getIn(['businesses', 'selected']).toJS()],
		shallowEqual
	);

	return { selectedBusiness };
};
